import { Record } from 'immutable';
/** @deprecated Use `buildSenderLocatorKey` or `buildSenderLocatorObject`. */
export default Record({
  senderId: null,
  senderType: null
}, 'SenderLocator');